import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { DeleteWarningIcon } from "../ui/icons";
import { toast } from "react-toastify";
import { useSpinner } from "../../customHooks";
import {
  rebootDevice,
  resetRebootDeviceState,
} from "./rebootDeviceSlice";
import { RootState } from "../../store/index";
import { Status } from "../../common/constants";

interface Modal4RebootDeviceProps {
  deviceId: string;
  deviceDisplayName: string;
}

const Modal4RebootDevice: React.FC<Modal4RebootDeviceProps> = ({
  deviceId,
  deviceDisplayName,
}) => {
  const [show, setShow] = useState(false);

  const dispatch = useDispatch<any>();
  const { apiStatus } = useSelector(
    (state: RootState) => state.rebootDeviceApi
  );

  const isLoading = apiStatus === Status.PENDING;

  useSpinner(apiStatus);

  const handleClose = (): void => {
    if (!isLoading) {
      setShow(false);
      dispatch(resetRebootDeviceState());
    }
  };

  const handleShow = (): void => {
    setShow(true);
  };

  const handleReboot = async (): Promise<void> => {
    try {
      const responseMessage = await dispatch(rebootDevice({ deviceId })).unwrap();

      toast.success(
        responseMessage ||
          `Reboot command sent to device ${deviceDisplayName}. The device may go offline for a few seconds while restarting.`
      );

      setShow(false);
      dispatch(resetRebootDeviceState());
    } catch (error: any) {
      toast.error(error || "Failed to send reboot command. Please try again.");
      dispatch(resetRebootDeviceState());
    }
  };

  return (
    <>
      <div className="dropdown-item-btn" onClick={handleShow}>
        Reboot
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        className="modal-container"
        centered
        backdrop={isLoading ? "static" : true}
        keyboard={!isLoading}
      >
        <div className="reboot-modal-wrapper">
          <Modal.Header closeButton={!isLoading}>
            <Modal.Title>
              <div className="delete-heading">
                <DeleteWarningIcon />
                <h1>Reboot Device</h1>
              </div>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>Are you sure you want to reboot “{deviceDisplayName}”?</p>
            <p>The device may go offline for a few seconds while restarting.</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="btn-cancel"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              className="btn-delete"
              onClick={handleReboot}
              disabled={isLoading}
            >
              {isLoading ? "Rebooting..." : "Reboot"}
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export default Modal4RebootDevice;